module.exports = "<router-outlet #appRouter=\"outlet\"></router-outlet>"